import router from '@/router'

async function goToPage (name, params) {
  await router
    .push({ name, params })
    .catch(error => console.error(error))
}

function prevPage () {
  if (router.currentRoute.path !== '/') {
    router.back()
  }
}

export {
  goToPage,
  prevPage
}
